/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_CapabilitiesInputs */

const en_footer_risks_capabilities = /** @type {(inputs: Footer_Risks_CapabilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dangerous capabilities`)
};

/**
* | output |
* | --- |
* | "Dangerous capabilities" |
*
* @param {Footer_Risks_CapabilitiesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_capabilities = /** @type {((inputs?: Footer_Risks_CapabilitiesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_CapabilitiesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_capabilities(inputs)
});